import ReferencialAppList from '../../ReferencialAppList'
import React, { useMemo } from 'react'
import { sortBy } from 'lodash'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { push } from '@lagunovsky/redux-react-router'
import i18n from 'simple-react-i18n'
import UsageAction from '../actions/UsageAction'
import HomeAction from '../../../../home/actions/HomeAction'
import Checkbox from '../../../../components/forms/Checkbox'
import { getSandreLabel } from '../../../../utils/StringUtil'
import ReferencialAction from '../../../action/ReferencialAction'
import useProgressDispatch from 'utils/customHook/useProgressDispatch'
import ProgressCard from 'components/card/ProgressCard'

const headersList = ['id', 'name', 'category', 'eligibility', 'culture', 'simplifiedCulture', 'multipleEntry', 'calculAuto', 'verifyCoherence', 'volumeRealEntry', 'showVolumeIfCounter']
const headersExport = ['id', 'name', 'category', 'eligibility', 'culture', 'simplifiedCulture', 'multipleEntry', 'calculAuto', 'verifyCoherence', 'volumeRealEntry', 'showVolumeIfCounter']

const UsagesApp = () => {
    const {
        usages,
        sandreCodes,
    } = useSelector(store => ({
        usages: store.UsageReducer.usages,
        sandreCodes: store.ReferencialReducer.sandreCodes,
    }), shallowEqual)

    const dispatch = useDispatch()

    const { isLoaded } = useProgressDispatch(() => [
        dispatch(ReferencialAction.fetchSandreCodes()),
        dispatch(UsageAction.fetchUsages()),
    ], [])


    const usagesFormatted = useMemo(() => {
        if (!isLoaded) {
            return []
        }
        return sortBy(usages, 'idUsage').map((u) => {
            return {
                ...u,
                name: u.description,
                category: getSandreLabel(sandreCodes, 'USAGES.CATEGORIE', u.category),
                eligibility: u.eligibility ? (<Checkbox checked disabled />) : '',
                culture: u.isCulture ? (<Checkbox checked disabled />) : '',
                multipleEntry: u.multipleEntry ? (<Checkbox checked disabled />) : '',
                calculAuto: u.calculAuto ? (<Checkbox checked disabled />) : '',
                verifyCoherence: u.checkCoherence ? (<Checkbox checked disabled />) : '',
                volumeRealEntry: u.volumeRealEntry ? (<Checkbox checked disabled />) : '',
                showVolumeIfCounter: u.showVolumeIfCounter ? (<Checkbox checked disabled />) : '',
                simplifiedCulture: u.simplifiedCulture ? (<Checkbox checked disabled />) : '',
                headers: headersExport,
            }
        })
    }, [isLoaded, sandreCodes, usages])

    if (isLoaded) {
        return (
            <ReferencialAppList
                title={i18n.usages}
                data={usagesFormatted}
                type={{ headers: headersList }}
                referenceData={usages}
                newAction={() => dispatch(push('/territory/settings/usage/new'))}
                onClick={({ id }) => dispatch(push(`/territory/settings/usage/${id}`))}
                setTitleAction={() => dispatch(HomeAction.setTitle([{
                    title: i18n.steering,
                    href: 'territory',
                }, {
                    title: i18n.settings,
                    href: 'territory/settings',
                }, {
                    title: i18n.usages,
                    href: 'territory/settings/usages',
                }]))}
                showUpdateButton={false}
                showPurgeButton={false}
                showRefencialActionsButton={false}
                round
            />
        )
    }
    return (
        <div className='padding-1'>
            <ProgressCard indeterminate withMessage round />
        </div>
    )
}

export default UsagesApp